<template>
  <div class="container">
    <template v-if="tagDetail">
      <Header model-type="1" :brand-image="tagDetail.brandPicture"/>


      <template v-if="isBrandUser">
        <div class="content-wrap">
          <DeviceName
              v-if="tagDetail.oilType === 2 && tagDetail.deviceType === 3"
              style="marin-top:12px;"
              show-edit
              :device-name="tagDetail.deviceName"
              :device-id="tagId"
              @onUpdateDeviceName="onUpdateDeviceName"/>
          <div class="card" v-if="showSpecification && tagDetail.oilType === 2 && tagDetail.deviceType === 3">
            <Specification :series-data="ingredientSeries" @click="onGotoSetFlavor"/>
          </div>


          <div v-if=" tagDetail.oilType === 2 && tagDetail.deviceType === 7">
            <NicoDeviceInfo
                show-edit
                @onUpdateDeviceName="onUpdateDeviceName"
                @onFavoriteDevice="onFavoriteDevice"
                :device-info="tagDetail"/>

          </div>
          <div class="card">
            <PowerCurve
                ref="powerCurve"
                :powers="powers"
                :r="r"
                :max-voltage="maxVoltage"
                :min-voltage="minVoltage"
                @change="onVoltagesChange"/>
          </div>
          <div class="card">
            <DeviceParams :disabled="disabledLevel" :level="level" :r="r" @change="onDeviceLevelChange"/>
          </div>

          <div class="flex flex-row items-center text-center gap-3 mt-10 ml-4 mr-4">
            <div @click="onAllHistoryClick" class="flex-1 bg-white curve-list-btn">All History</div>
            <div @click="onMyCurveListClick" class="flex-1 text-white curve-list-btn"
                style="background: #121212">My Curve List
            </div>
          </div>
        </div>
      </template>


      <template v-else>
        <div class="consumer-content-wrap">
          <div class="advertise" v-if="showAdvertiseBar">
            <div class="flex-1 marquee" @click="onAdvertiseClick">
              <!--              <div class="marquee-content">-->
              <!--                <span>Zoom advertisement to this page</span>-->
              <!--                <span>Zoom advertisement to this page</span>-->
              <!--              </div>-->
              <vue-marquee :msg="powers" :speed="10" direction="row">
                <span class="third-color">{{ advertiseData.eventName }}</span>
              </vue-marquee>
            </div>
            <img style="width:16px;height:16px;" @click.stop="showAdvertiseBar=false"
                :src="require('@/assets/icons/consumer/ic_advertise_close.png')"></img>
          </div>
          <DeviceInfo
              v-if="tagDetail && tagDetail.oilType === 2 && tagDetail.deviceType === 3"
              :flavor-tag="tagDetail.flavorName"
              :label-tag="tagDetail.commodityLabelId"
              show-edit
              :flavor-image="tagDetail.flavorPicture"
              :device-name="tagDetail.deviceName"
              :device-id="tagId"
              :is-favorite="tagDetail.isFavorite"
              :ingredient-text="ingredientsText"
              @onFavoriteDevice="onFavoriteDevice"
              @onUpdateDeviceName="onUpdateDeviceName"/>

          <div v-if="tagDetail && tagDetail.oilType === 2 &&  tagDetail.deviceType === 7" key="consumer-nico">
            <NicoDeviceInfo
                show-edit
                @onUpdateDeviceName="onUpdateDeviceName"
                @onFavoriteDevice="onFavoriteDevice"
                :device-info="tagDetail"/>
          </div>


          <div class="power-curve-card">
            <PowerCurve
                ref="powerCurve"
                :powers="powers"
                :r="r"
                :show-label="false"
                :has-recommend-curve="tagDetail.voltageCurveList.length > 0"
                :grid="consumerPowerCurveGrid"
                :max-voltage="maxVoltage"
                :min-voltage="minVoltage"
                @change="onVoltagesChange"/>
          </div>
          <div style="margin-left:16px;">
            <SystemCurve @click="onRecommendClick" @onFavoriteClick="onCurveFavoriteClick"
                :current-selected-index="selectedCurveIndex" :curves="tagDetail.voltageCurveList"/>
          </div>

          <!--        <div class="card">-->
          <!--          <DailyUsage/>-->
          <!--        </div>-->

          <!--        <div class="week-month-usage-card">-->
          <!--          <WeekMonthUsage/>-->
          <!--        </div>-->
        </div>
      </template>

      <BottomOperate :func-type="funcType" :disabled="disabledNfcButton"
          @onFuncTypeChange="onFuncTypeChange"
          @onWrite="onWrite" @onRead="onRead"/>

      <PopupAd v-model="showAdvertise" :advertise="advertiseData"/>
    </template>

    <template v-if="showUserGuide">
      <div class="nfc-mask">
        <NFCGuideMask :func-type="2" v-model="showUserGuide" @onRead="onRead"
            @onFuncTypeChange="onFuncTypeChange"/>
      </div>

    </template>


    <NFCPopup v-model="showNfcPopup" :msg="androidPopupMsg"/>

    <PopupDeviceCurve
        show-button
        v-if="showNfcScanResult"
        v-model="showNfcScanResult"
        :loading="tagInfoLoading"
        :ingredient-text="ingredientsText"
        :level="level"
        :legal-device="legalDevice"
        :tag-id="tagId"
        @close="onScanResultClose"
        :device-name="(tagDetail && tagDetail.deviceName) || ''"
        :power="currentPower"/>

    <PopupConsumerDeviceCurve
        show-button
        v-if="showNfcConsumerScanResult"
        v-model="showNfcConsumerScanResult"
        :loading="tagInfoLoading"
        :ingredient-text="ingredientsText"
        :level="level"
        :flavor-tag="(tagDetail && tagDetail.commodityLabelId) || ''"
        :legal-device="legalDevice"
        :tag-id="tagId"
        :flavor-image="(tagDetail && tagDetail.flavorPicture) || ''"
        :device-name="(tagDetail && tagDetail.deviceName) || ''"
        :power="currentPower"/>
    <PopupNicoDeviceCurve
        show-button
        v-if="showNicoScanResult"
        v-model="showNicoScanResult"
        :loading="tagInfoLoading"
        :ingredient-text="ingredientsText"
        :level="level"
        :device-type="tagDetail.deviceType"
        :flavor-tag="(tagDetail && tagDetail.flavorName) || ''"
        :legal-device="legalDevice"
        :tag-id="tagId"
        :flavor-image="(tagDetail && tagDetail.flavorPicture) || ''"
        :device-name="(tagDetail && tagDetail.deviceName) || ''"
        :power="currentPower"/>
  </div>
</template>

<script>
import DeviceName from "@/components/home/DeviceName";
import Header from "@/components/home/Header";
import Specification from "@/components/home/Specification";
import BottomOperate from "@/components/home/BottomOperate";
import DeviceParams from "@/components/home/DeviceParams";
import PowerCurve from "@/components/home/PowerCurve.vue";
import {
  calcPower,
  calcVoltageFloorInt, checkDeviceLegal,
  convertTagId,
  findDeviceR,
  isAndroid,
  NICOTINE,
  openExternalUrl, THC
} from "@/util/utils";
import NFCPopup from "@/components/nfc/NFCPopup.vue";
import { SUFFIX_FLAG, WriterSetting } from "@/bluetooth/BluetoothData";
import StoreType, { NFC_MODULE_NAME } from "@/store/StoreType";
import nfcRepository from "@/nfc/NFCRepository";
import { mapState } from "vuex";
import PopupDeviceCurve from "@/components/PopupDeviceCurve.vue";
import user from "@/api/user";
import log from "@/util/log";
import NFCGuide from "@/components/home/NFCGuide.vue";
import userMixin from "@/mixins/userMixin";
import device from "@/api/device";
import DeviceInfo from "@/components/home/DeviceInfo.vue";
import Usage from "@/components/Usage.vue";
import SystemCurve from "@/components/home/SystemCurve.vue";
import WeekMonthUsage from "@/components/WeekMonthUsage.vue";
import DailyUsage from "@/components/DailyUsage.vue";
import PopupConsumerDeviceCurve from "@/components/PopupConsumerDeviceCurve.vue";
import NFCGuideMask from "@/components/home/NFCGuideMask.vue";
import OtpCode from "@/components/common/OtpCode.vue";
import VueMarquee from "@/components/home/VueMarquee.vue";
import PopupAd from "@/components/common/PopupAd.vue";
import PopupNicoDeviceCurve from "@/components/PopupNicoDeviceCurve.vue";
import NicoDeviceInfo from "@/components/home/NicoDeviceInfo.vue";

export default {
  name: "EnterpriseHome",
  mixins: [userMixin],
  components: {
    NicoDeviceInfo,
    PopupNicoDeviceCurve,
    PopupAd,
    VueMarquee,
    OtpCode,
    NFCGuideMask,
    PopupConsumerDeviceCurve,
    DailyUsage,
    WeekMonthUsage,
    SystemCurve,
    Usage,
    DeviceInfo,
    NFCGuide,
    PopupDeviceCurve,
    NFCPopup,
    PowerCurve,
    DeviceParams,
    BottomOperate,
    Specification,
    Header,
    DeviceName

  },
  props: {},
  data() {
    return {
      msgData: "",
      showAdvertise: false,
      showAdvertiseBar: false,
      advertiseData: null,
      powers: [[1, 4.2], [2, 3.8], [3, 1.8], [4, 4.3], [5, 4.5], [6, 8.5], [7, 6.5], [8, 6.1]],
      lastPowers: [[1, 4.2], [2, 3.8], [3, 1.8], [4, 4.3], [5, 4.5], [6, 8.5], [7, 6.5], [8, 6.1]],
      devicePowers: [],
      maxVoltage: 3500,
      minVoltage: 300,
      r: 1.2,
      level: 0,

      showNfcPopup: false,
      disabledNfcButton: false,
      androidPopupMsg: {
        title: "Ready to Read",
        message: "Place your product in the NFC area"
      },
      typeOfDevice: 1,
      disabledLevel: true,

      funcType: 2, //1是蓝牙 2是nfc

      showNfcScanResult: false,
      showNfcConsumerScanResult: false,
      showNicoScanResult: false,
      tagId: "",
      legalDevice: false,

      tagInfoLoading: false,
      ingredientsText: "",
      tagDetail: null,
      ingredientSeries: [],
      showUserGuide: false,

      consumerPowerCurveGrid: { top: "10%", bottom: "40px", right: "16px", left: "32px" },

      consumerCurve: null,
      isFirstLoad: true,


      isOperateNFCSuccess: false,
      selectedCurveIndex: -1,
      prevSelectedCurveIndex: -1

    };
  },
  methods: {
    onScanResultClose() {
      if (this.isFirstLoad) {
        this.isFirstLoad = false;
        this.loadCacheDeviceInfo();
      }
    },
    onAdvertiseClick() {
      const { id, eventName, isExternalEvent, externalEventLink } = this.advertiseData;
      if (isExternalEvent) {
        openExternalUrl(externalEventLink);
        return;
      }
      this.$router.push({
        name: "NotificationsDetail",
        query: {
          newsId: id,
          title: eventName
        }
      });
    },
    async onFavoriteDevice() {
      try {
        const isFavorite = this.tagDetail.isFavorite === 1;
        const resp = await user.favoriteDevice({
          isFavorite: isFavorite ? 0 : 1,
          tag: this.tagDetail.tagId
        });
        if (resp.code !== 200) {
          this.$toast({
            type: "fail",
            message: resp.message
          });
          return;
        }
        this.tagDetail.isFavorite = isFavorite ? 0 : 1;
        this.cacheTagData(this.tagDetail);
        this.$toast({
          type: "success",
          message: resp.message
        });
      } catch (e) {
        console.log(e);
        this.$toast({
          type: "fail",
          message: e
        });
      }
    },
    onGotoSetFlavor() {
      if (this.tagDetail.id) {
        if (this.tagDetail.isItEmpty === 0) {
          this.$toast({
            message: "This device is empty device，Please complete the device information"
          });
          return;
        }
        if (this.tagDetail.isBrand !== 0) {
          this.$toast({
            message: "This device is not your brand"
          });
          return
        }

        this.$router.push({
          path: "/set-flavor",
          query: {
            brandId: this.tagDetail.brandId,
            productId: this.tagDetail.deviceId,
            id: this.tagDetail.flavorId
          }
        });
      }else {
        this.$toast({
          message: "Please try again after read the legal device."
        });
      }
    },
    onCurveFavoriteClick(item, index) {
      this.selectedCurveIndex = index;
    },
    onRecommendClick(item, index) {
      this.selectedCurveIndex = index;
      this.consumerCurve = item;
      const voltages = item.heatingVoltage.split(",");

      const maxPower = calcPower(this.maxVoltage, this.r, 10);
      // this.copyPowers()
      voltages.forEach((item, index) => {
        this.powers[index][1] = calcPower(item, this.r, maxPower);
      });

      this.$set(this.powers, 0, this.powers[0]);
      this.$refs.powerCurve.refreshCurve(this.isBrandUser);
      this.onWrite(item.position);
    },
    onUpdateDeviceName(content) {
      this.tagDetail.deviceName = content;
      this.cacheTagData(this.tagDetail);
    },
    getVoltages() {
      return this.powers.map((item) => {
        return calcVoltageFloorInt(item[1], this.r);
      });
    },
    onDeviceLevelChange(val) {
      this.level = val;
    },
    onAllHistoryClick() {
      this.$router.push({
        name: "History",
        query: {
          modelType: 1
        }
      });
    },
    onMyCurveListClick() {
      this.$router.push({
        name: "Favorite",
        query: {
          modelType: 1
        }
      });
    },
    onVoltagesChange(powers) {
      this.powers = powers;
    },

    //底部操作
    onFuncTypeChange(e) {
      log(`func type = ${e}`);
      if (e === 1) {
        //bt
        if (this.showUserGuide) {
          this.$router.replace("/hub-devices");
          return;
        }
        this.$router.replace("/bt-home");

      } else {
        // nfc
        this.$router.replace("/enterprise");
      }
    },

    setIngredientsToPieChart(ingredientsVoList) {

      const ingredientSeries = ingredientsVoList
          .filter(item => (item.id > 0 || item.id === -1000) && item.proportion > 0)
          .map(item => {
            return { value: item.proportion || 0, name: item.name };
          });

      log(ingredientSeries);
      this.ingredientSeries = ingredientSeries;
    },

    //NFC监听
    getNFCReader(isRead = true) {
      if (this.disabledNfcButton) {
        return null;
      }
      const nfcReader = navigator.nfcReader;
      if (!nfcReader) {
        this.$dialog.alert({
          message: "Current environment not support this function,Please download app to use it"
        });
        return null;
      }

      if (!this.isInitErrorHandler) {
        nfcReader.addEventListener(
            "receiveInvalidateWithError",
            this.handlerNFCError
        );
        this.isInitErrorHandler = true;
      }

      if (!this.isInitBegingEvent) {
        nfcReader.addEventListener(
            "receiveBegingActive",
            this.handleBeingActive
        );
        this.isInitBegingEvent = true;
      }

      if (isRead) {
        this.androidPopupMsg = {
          title: this.isBranduser ? "Read to connect" : "Ready to Read",
          message: "Place your product in the NFC area"
        };
      } else {
        this.androidPopupMsg = {
          title: "Ready to Write",
          message: "Place your product in the NFC area"
        };
      }

      this.showNfcPopup = isAndroid();
      if (!this.showNfcPopup) {
        this.disabledNfcButton = true;
      }
      return nfcReader;
    },

    handlerNFCError(event) {
      log("出现错误 " + JSON.stringify(event.error));
      if (event.error.errorCode !== 200) {
        // navigator.nfcReader.endReaderSession(false, "");
      }
      if (!this.isOperateNFCSuccess) {
        console.log(`恢复选中状态 ${this.prevSelectedCurveIndex}`);
        this.selectedCurveIndex = this.prevSelectedCurveIndex;

        // this.lastPowers.forEach((item, index) => {
        //   this.powers[index][1] = item[1];
        // });
        // this.$set(this.powers, 0, this.powers[0]);
        // this.$refs.powerCurve.refreshCurve(this.isBrandUser);
      }
      this.isOperateNFCSuccess = false;
      log(`disabledNfcButton before = ${this.disabledNfcButton}`);
      this.disabledNfcButton = false;
      log(`disabledNfcButton after= ${this.disabledNfcButton}`);
    },
    handleBeingActive(event) {
      log("handleBeingActive ");
      // this.toastObj.clear();
    },

    async onRead() {
      if (this.disabledNfcButton) {
        return;
      }

      const nfcReader = this.getNFCReader();
      if (!nfcReader) {
        return;
      }

      const session = await nfcReader.beginReaderSession(2, {
        operate: 2,
        alertMessage: "Place your product in the NFC area."
      });
      log(`tag id = ${session.id}`);

      try {

        await session.connect();

        const { level, groupNumber } = await nfcRepository.readDeviceLevel(session);
        this.level = level;
        const isSupportLevel = (level > 0);

        this.disabledLevel = !isSupportLevel

        const flag = await nfcRepository.readDeviceFlag(session, isSupportLevel);
        log(`flag = ${flag}`);
        if (flag !== SUFFIX_FLAG) {
          throw ("No support device");
        }

        const oilBattery = await nfcRepository.readDeviceOilBattery(session);
        const currentVoltages = oilBattery.getBatteryValue(this.typeOfDevice);
        const { currentSeconds, maxSeconds } = oilBattery.getLiquidValue(this.typeOfDevice);
        const batteryPercent = oilBattery.getBatteryPercent(this.typeOfDevice);
        const liquidPercent = oilBattery.getLiquidPercent(this.typeOfDevice);

        const deviceInfoDataView = await nfcRepository.readDeviceInfo(session, level);

        const typeOfDevice = await nfcRepository.readDeviceType(session);
        this.typeOfDevice = typeOfDevice;

        this.r = findDeviceR(typeOfDevice, groupNumber);
        log(`当前的设备的阻值为 ${this.r}`);

        const maxPower = calcPower(this.maxVoltage, this.r, 10);


        const writerSetting = new WriterSetting(deviceInfoDataView);
        if (isSupportLevel) {
          writerSetting.diyVoltage = writerSetting.diyVoltage.slice((level - 1) * 8, level * 8);
        }
        this.$store.commit(
            `${NFC_MODULE_NAME}${StoreType.COMMIT_TYPE.STATE_CURRENT_WRITER_SETTING}`,
            writerSetting
        );

        log(`计算之前，看看阻值：${this.r}`);
        writerSetting.diyVoltage.forEach((item, index) => {
          this.powers[index][1] = calcPower(item, this.r, maxPower);
        });
        //强制刷新组件的props，里面用到了computed
        this.$set(this.powers, 0, this.powers[0]);

        log(`读取的电压为 ： ${writerSetting.diyVoltage}`);
        log(`读取的功率为 ： ${this.powers}`);

        const tagId = convertTagId(session.id);
        this.tagId = tagId;


        await this.$store.dispatch("nfc/saveCurve", this.powers);
        nfcReader.endReaderSession(true, "Read Success!");

        let tagInfo;
        try {
          tagInfo = await user.tagDetail({ tagId }, true);


          tagInfo.tagId = tagId;
          tagInfo.battery = batteryPercent;
          tagInfo.liquid = liquidPercent;
          tagInfo.currentSeconds = currentSeconds;

          this.legalDevice = checkDeviceLegal(tagInfo, this.isBrandUser);
          if (!this.legalDevice) {
            this.tagInfoLoading = false;
            if (this.isBrandUser) {
              this.showNfcScanResult = true;
            } else {
              this.showNfcConsumerScanResult = true;
            }
            return;
          }

          gtag("event", "read-device", {
            'event_category': 'nfc',
            'event_label': 'read-button',
            'value': {
              isBrand: this.isBrandUser,
              brandName: tagInfo.brandName,
              flavor: tagInfo.flavorName
            }
          });
          if (tagInfo.oilType === 1) {
            try {
              this.cacheTagData(tagInfo);
              await this.$router.replace("/nico");
            } catch (e) {

            }
            return;
          }
          this.setAndUploadData(tagInfo);
          this.$store.dispatch("nfc/uploadUserUsageHistory", {
            tagId,
            battery: currentVoltages,
            currentSeconds: currentSeconds,
            maxSeconds: maxSeconds
          });
          if (tagInfo.oilType === 1) {
            this.showNicoScanResult = true;
          } else {
            if (this.isBrandUser) {
              this.showNfcScanResult = true;
            } else {
              this.showNfcConsumerScanResult = true;
            }
          }
        } catch (e) {
          log(e);
        } finally {
        }
      } catch (e) {
        log(e);
        if (isAndroid()) {
          this.$toast({
            type: "fail",
            message: e,
            duration: 2000
          });
        }
        nfcReader.endReaderSession(false, e);
      } finally {
        if (this.showNfcPopup) {
          this.showNfcPopup = false;
          this.disabledNfcButton = false;
        }
      }

      log(`开始读取设备`);
    },
    async onWrite(curveLevel) {
      if (this.disabledNfcButton) {
        return;
      }

      const nfcReader = this.getNFCReader(false);
      if (!nfcReader) {
        return;
      }

      let tagId = null;
      const voltages = this.getVoltages();
      try {
        const session = await nfcReader.beginReaderSession(2, {
          operate: 2,
          alertMessage: "Please move your device near the top your phone to write device."
        });
        tagId = convertTagId(session.id);

        await session.connect();

        const { level, groupNumber } = await nfcRepository.readDeviceLevel(session);
        const isSupportLevel = (level > 0);
        if (!isSupportLevel) {
          this.level = 1
        }
        this.disabledLevel = !isSupportLevel;

        const flag = await nfcRepository.readDeviceFlag(session, isSupportLevel);
        log(`flag = ${flag}`);
        if (flag !== SUFFIX_FLAG) {
          throw ("No support device");
        }

        const oilBattery = await nfcRepository.readDeviceOilBattery(session);
        const currentVoltages = oilBattery.getBatteryValue(this.typeOfDevice);
        const { currentSeconds, maxSeconds } = oilBattery.getLiquidValue(this.typeOfDevice);
        const batteryPercent = oilBattery.getBatteryPercent(this.typeOfDevice);
        const liquidPercent = oilBattery.getLiquidPercent(this.typeOfDevice);


        const typeOfDevice = await nfcRepository.readDeviceType(session);

        this.r = findDeviceR(typeOfDevice, groupNumber);
        log(`当前的设备的阻值为 ${this.r}`);

        const maxPower = calcPower(this.maxVoltage, this.r, 10);
        const writerSetting = new WriterSetting();
        writerSetting.diyVoltage = voltages;


        if (isSupportLevel) { //设备支持档位的，根据推荐曲线来
          if (curveLevel) {
            const writeLevel = curveLevel > 0 && curveLevel < 4 ? curveLevel : this.level; //判断推荐曲线的值，超过了使用设备里面的
            await nfcRepository.writeDeviceCurve(session, writerSetting, writeLevel);
            this.level = writeLevel;
          } else {
            await nfcRepository.writeDeviceCurve(session, writerSetting, this.level);
          }

          await nfcRepository.writeDeviceLevel(session, this.level, groupNumber);
        } else {
          await nfcRepository.writeDeviceCurve(session, writerSetting, level);
        }
        this.prevSelectedCurveIndex = this.selectedCurveIndex;

        this.$store.dispatch("nfc/saveCurve", this.powers);

        this.$refs.powerCurve.refreshCurve(this.isBrandUser);

        nfcReader.endReaderSession(true, "Write success");

        this.isOperateNFCSuccess = true;

        try {
          const tagInfo = await user.tagDetail({ tagId }, true);
          tagInfo.tagId = tagId;
          tagInfo.battery = batteryPercent;
          tagInfo.liquid = liquidPercent;
          tagInfo.currentSeconds = currentSeconds;
          this.legalDevice = checkDeviceLegal(tagInfo, this.isBrandUser);
          if (!this.legalDevice) {
            this.ingredientsText = "";
            this.tagInfoLoading = false;
            this.setIngredientsToPieChart([]);
            this.showNfcScanResult = false;
            return;
          }
          gtag("event", "write-device", {
            'event_category': 'nfc',
            'event_label': 'write-button',
            'value': {
              isBrand: this.isBrandUser,
              brandName: tagInfo.brandName,
              flavor: tagInfo.flavorName
            }
          });
          if (tagInfo.oilType === NICOTINE /*&& tagInfo.brandName.toLowerCase() === "zofo"*/) {
            try {
              this.cacheTagData(tagInfo);
              await this.$router.replace("/nico");
            } catch (e) {

            }
            this.setAndUploadData(tagInfo);
            return;
          }
          this.setAndUploadData(tagInfo);
          this.uploadTagData(tagId, writerSetting, maxPower, currentVoltages, currentSeconds, maxSeconds);
        } catch (e) {
          log(e);
        } finally {
        }
      } catch (e) {
        if (isAndroid()) {
          this.$toast({
            type: "fail",
            message: e,
            duration: 2000
          });
        }
        this.isOperateNFCSuccess = false;
        nfcReader.endReaderSession(false, e);
      } finally {

        if (this.showNfcPopup) {
          this.showNfcPopup = false;
          this.disabledNfcButton = false;
        }
      }
    },

    cacheTagData(tagDetail) {
      if (this.isBrandUser) {
        this.$store.commit("nfc/setDefaultBusinessTagData", tagDetail);
        this.showUserGuide = false;
      } else {
        this.$store.commit("nfc/setDefaultConsumerTagData", tagDetail);
        this.showUserGuide = false;
      }
      this.$store.dispatch("bluetooth/setShowBtGuide", true);

      this.$nextTick(() => {
        this.$refs.powerCurve.refreshCurve(this.isBrandUser);
      });
    },
    setAndUploadData(tagInfo) {
      this.showUserGuide = false;
      this.cacheTagData(tagInfo);
      //为空或者长度为0
      const combineList = [].concat(tagInfo.ingredientsVoList || []).concat(tagInfo.terpenesList || [])
          .sort((prev, current) => {
            return current.proportion - prev.proportion;
          });

      this.ingredientsText = combineList.map(item => `${item.proportion}% ${item.name}`).join("+");
      this.tagInfoLoading = false;
      this.setIngredientsToPieChart(combineList);
      this.tagDetail = tagInfo;

      this.$store.dispatch("nfc/activeTag", tagInfo.tagId);
    },

    uploadTagData(tagId, writerSetting, maxPower, currentVoltages, currentSeconds, maxSeconds) {
      //上传到服务器
      device.uploadConfig(
          (this.consumerCurve && this.consumerCurve.id) || 0,
          (this.consumerCurve && this.consumerCurve.modeName) || "Customizer",
          this.r,
          maxPower,
          null,
          null,
          null,
          navigator.bluetooth2 ? process.env.APP_ANDROID_VERSION : process.env.APP_IOS_VERSION,
          writerSetting,
          tagId,
          null
      );

      this.$store.dispatch("nfc/uploadUserUsageHistory", {
        tagId,
        battery: currentVoltages,
        currentSeconds: currentSeconds,
        maxSeconds: maxSeconds
      });
    },
    loadCacheDeviceInfo() {

      this.maxVoltage = calcVoltageFloorInt(10, this.r);
      this.minVoltage = calcVoltageFloorInt(0.1, this.r);

      const defaultHomeData = this.isBrandUser ? this.defaultBHomeData : this.defaultCHomeData;
      console.log(defaultHomeData);
      if (!!defaultHomeData) {
        if (defaultHomeData.oilType === NICOTINE /*&& defaultHomeData.brandName.toLowerCase() === "zofo"*/) {
          this.$router.replace("/nico");
          return;
        }
        this.legalDevice = true;
        this.tagDetail = defaultHomeData;

        const tagId = defaultHomeData.tagId;
        this.tagId = tagId;
        const combineList = [].concat(defaultHomeData.ingredientsVoList || []).concat(defaultHomeData.terpenesList || [])
            .sort((prev, current) => {
              return current.proportion - prev.proportion;
            });
        this.setIngredientsToPieChart(combineList);
        this.ingredientsText = combineList.map(item => `${item.proportion}% ${item.name}`).join("+");

        new Promise(async (resolve, reject) => {
          const tagInfo = await user.tagDetail({ tagId }, false);
          if (tagInfo.id == null) {
            this.legalDevice = false;
            return;
          }
          tagInfo.tagId = tagId;

          const combineList = [].concat(defaultHomeData.ingredientsVoList || []).concat(defaultHomeData.terpenesList || [])
              .sort((prev, current) => {
                return current.proportion - prev.proportion;
              });
          this.setIngredientsToPieChart(combineList);
          this.ingredientsText = combineList.map(item => `${item.proportion}% ${item.name}`).join("+");

          this.tagDetail = { ...this.tagDetail, ...tagInfo };
          this.cacheTagData(this.tagDetail);
          resolve();
        });
        return;
      } else {
        this.showUserGuide = true;//process.env.NODE_ENV !== 'dev';
      }
    },
    async loadAd() {

      if (!this.isBrandUser) {
        const resp = await user.selectAdvertise({}, false);
        if (resp.code === 200) {
          const advertiseData = resp.data;
          this.$nextTick(() => {
            if (advertiseData) {
              this.advertiseData = advertiseData;
              this.showAdvertise = true;
              this.showAdvertiseBar = true;
            }
          });

        }
        this.isFirstLoad = false;
      }
    },
    copyPowers() {
      this.powers.forEach((item, index) => {
        this.lastPowers[index][1] = item[1];
      });
    }
  },
  computed: {
    ...mapState("nfc", ["writerSetting", "defaultBHomeData", "defaultCHomeData", "deviceCurve"]),
    //是否显示成分
    showSpecification() {
      if (this.typeOfDevice > 0 && this.funcType === 2) {
        return true;
      }
      return false;
    },
    //从linechart中取出y值
    currentPower() {
      return this.powers.map(item => item[1]);
    }
  },
  watch: {
    showNfcConsumerScanResult(val) {
      if (!val && this.isFirstLoad) {
        this.isFirstLoad = false;
        this.loadAd();
      }
    },

    showNfcPopup(val) {
      if (!val && isAndroid()) {
        if (!this.isOperateNFCSuccess) {
          console.log(`恢复选中状态 ${this.prevSelectedCurveIndex}`);
          this.selectedCurveIndex = this.prevSelectedCurveIndex;

          // this.lastPowers.forEach((item, index) => {
          //   this.powers[index][1] = item[1];
          // });
          //
          // this.$set(this.powers, 0, this.powers[0]);
          // this.$refs.powerCurve.refreshCurve(this.isBrandUser);
        }
        this.isOperateNFCSuccess = false;
      }
    }

  },
  async mounted() {
    console.log(`mounted`);
    // this.loadCacheDeviceInfo();
    //测试用
    // const tagId = "173333DB100153E0"
    // const tagInfo = await user.tagDetail({ tagId });
    // this.ingredientsText = tagInfo.ingredientsVoList.map(item => `${item.proportion}% ${item.name}`).join("+");
    // this.tagDetail = tagInfo;
    // this.tagInfoLoading = false;
    // const ingredientSeries = tagInfo.ingredientsVoList
    //     .filter(item => (item.id > 0 || item.id === -1000) && item.proportion > 0)
    //     .map(item => {
    //       return { value: item.proportion || 0, name: item.name };
    //     });
    //
    // log(ingredientSeries)
    // this.ingredientSeries = ingredientSeries

    // this.typeOfDevice = 75;
    // this.showNfcScanResult = true;

    const defaultHomeData = this.isBrandUser ? this.defaultBHomeData : this.defaultCHomeData;
    if (defaultHomeData) {
      this.loadAd();
    } else {
      this.isFirstLoad = true;
    }
  },

  async activated() {

    this.powers = this.deviceCurve;
    this.$nextTick(() => {

      if (this.$refs.powerCurve) {
        // this.copyPowers()
        this.$refs.powerCurve.refreshCurve(this.isBrandUser);
      }
    });

    console.log(`activeed`);
    this.loadCacheDeviceInfo();


    // this.showUserGuide = true;//await this.$store.dispatch("nfc/checkShowNfcGuide");
    log(this.showUserGuide);
    if (this.isBrandUser) {
      //TODO: 显示年龄认证
    }


    localStorage.setItem("last_path", "/Enterprise");
    const writerSetting = this.$route.params.writerSetting;
    if (writerSetting) {
      this.$nextTick(() => {
        writerSetting.diyVoltage.forEach((item, index) => {
          this.powers[index][1] = calcPower(Math.abs(item), this.r, this.maxPower);
        });
        log(`读取的电压为 ： ${writerSetting.diyVoltage}`);
        log(`读取的功率为 ： ${this.powers}`);

        this.$refs.powerCurve.refreshCurve(this.isBrandUser);
      });
    }
  }
};
</script>

<style scoped lang="less">
.consumer-content-wrap {
  position: absolute;
  overflow-y: auto;
  width: 100%;
  height: calc(100vh - 44px - calc(70px + env(safe-area-inset-bottom)));
  margin-top: 44px;

  & > * {
    margin-top: 12px;
  }

}

.content-wrap {
  position: absolute;
  overflow-y: auto;
  width: 100%;
  height: calc(100vh - 44px - calc(70px + env(safe-area-inset-bottom)));
  margin-top: 44px;

  & > * {
    margin-top: 12px;
  }
}


.curve-list-btn {
  height: 40px;
  line-height: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.container {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  padding-bottom: 16px;
}

.curve-list-btn {
  height: 40px;
  line-height: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.horizontal-padding {
  padding: 0 16px;
}

.power-curve-card {
  //bg-white default-radius pl-4 pr-4 pt-2.5 pb-2.5
  background: white;
  border-radius: 12px;
  padding: 10px 16px 0 16px;
  margin-left: 16px;
  margin-right: 16px;
}

.card {
  //bg-white default-radius pl-4 pr-4 pt-2.5 pb-2.5
  background: white;
  border-radius: 12px;
  padding: 10px 16px;
  margin-left: 16px;
  margin-right: 16px;
}

.card-last {
  //bg-white default-radius pl-4 pr-4 pt-2.5 pb-2.5
  background: white;
  border-radius: 12px;
  padding: 10px 16px;
  margin-bottom: 12px;
}

.advertise {
  margin-top: 0;
  color: #999999;
  background: #e4e5e9;
  font-size: 12px;
  font-weight: lighter;
  padding: 8px 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  .marquee {
    overflow: hidden; /* 溢出隐藏 */
    white-space: nowrap; /* 内容不换行 */

    .marquee-content {
      display: inline-block; /* 内容块级元素 */
      animation: marquee 5s linear infinite; /* 滚动动画，持续时间10秒，线性动画，无限循环 */
    }
  }
}

@keyframes marquee {
  0% {
    transform: translateX(200%); /* 起始位置 */
  }
  100% {
    transform: translateX(-100%); /* 结束位置 */
  }
}

.week-month-usage-card {
  margin-left: 16px;
  margin-right: 16px;
  margin-bottom: 12px;
}

.nfc-mask {
  padding: 0px;
}
</style>